/**
 * Email Management Permission Utilities
 * 
 * This module contains helper functions to validate user permissions
 * for email management features according to business requirements.
 */

/**
 * Roles allowed to access email management features
 */
export const EMAIL_MANAGEMENT_ALLOWED_ROLES = ['gestor', 'gestor_gc', 'e_commerce', 'delegado']

/**
 * Required permission for email management
 */
export const EMAIL_MANAGEMENT_PERMISSION = 'gestion_emails'

/**
 * Check if user has permission to access email management features
 * @param {string} role - User role
 * @param {Object} permissions - User permissions object
 * @returns {boolean} - True if user has permission
 */
export const hasEmailManagementPermission = (role, permissions) => {
  return (
    permissions?.[EMAIL_MANAGEMENT_PERMISSION] && 
    EMAIL_MANAGEMENT_ALLOWED_ROLES.includes(role)
  )
}

/**
 * Check if user can modify email status (blacklist/whitelist)
 * @param {string} role - User role
 * @param {Object} permissions - User permissions object
 * @returns {boolean} - True if user can modify email status
 */
export const canModifyEmailStatus = (role, permissions) => {
  return hasEmailManagementPermission(role, permissions)
}

/**
 * Check if user can create email exceptions
 * @param {string} role - User role
 * @param {Object} permissions - User permissions object
 * @returns {boolean} - True if user can create exceptions
 */
export const canCreateEmailException = (role, permissions) => {
  return hasEmailManagementPermission(role, permissions)
}
